import { render, staticRenderFns } from "./CptsTransactionDetail.vue?vue&type=template&id=76a8ed3b"
import script from "./CptsTransactionDetail.vue?vue&type=script&lang=js"
export * from "./CptsTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports